import { SelectablePaymentMethodEnum } from "config/site";
import {
  PaymentMethodEnum,
  PayoutMethodEnum,
} from "../../__generated__/globalTypes";

export function convertToPaymentMethod(
  selectablePaymentMethod: SelectablePaymentMethodEnum
) {
  if ([SelectablePaymentMethodEnum.Stripe].includes(selectablePaymentMethod)) {
    return PaymentMethodEnum.STRIPE;
  }

  if ([SelectablePaymentMethodEnum.Trustly].includes(selectablePaymentMethod)) {
    return PaymentMethodEnum.TRUSTLY;
  }

  if (
    [
      SelectablePaymentMethodEnum.TrustlyMdd,
      SelectablePaymentMethodEnum.TrustlyMddManual,
    ].includes(selectablePaymentMethod)
  ) {
    return PaymentMethodEnum.TRUSTLY_MDD;
  }

  throw new Error(
    `Can not convert selectable payment method ${selectablePaymentMethod} to payment method`
  );
}

export function convertToPayoutMethod(
  selectablePaymentMethod: SelectablePaymentMethodEnum
) {
  if ([SelectablePaymentMethodEnum.Stripe].includes(selectablePaymentMethod)) {
    return PayoutMethodEnum.PAYPAL;
  }

  if ([SelectablePaymentMethodEnum.Trustly].includes(selectablePaymentMethod)) {
    return PayoutMethodEnum.TRUSTLY;
  }

  if (
    [
      SelectablePaymentMethodEnum.TrustlyMdd,
      SelectablePaymentMethodEnum.TrustlyMddManual,
    ].includes(selectablePaymentMethod)
  ) {
    return PayoutMethodEnum.TRUSTLY_MDD;
  }

  throw new Error(
    `Can not convert selectable payment method ${selectablePaymentMethod} to payment method`
  );
}
